import Product from "@core/domain/product/product";
import Provider, {add, has} from "@core/domain/product/provider";
import {getAllSubstanceLists} from "@core/domain/substance";

export function fromCard(card) {
    if (has(card.id)) {
        let product = Provider(card.id);
        product.setCard(card);
        return product;
    }

    const product = new Product(card.id, getAllSubstanceLists());
    product.setCard(card);
    add(product);
    return product;
}
